module.exports = __webpack_public_path__ + "215220715dc4f05cf4205cd7c260fa72.svg";